export default __webpack_public_path__ + "static/media/20.e7e6cba3.jpg";